export class ProdutoTabelaEspecialItens {
  public idprodutoespecial: number;
  public idprodutotabelaespecial: number;
  public nome: string;
  public ativo: boolean;
  public preco: number;
  public unit: string;
  public guidclientenapis: string;
  public codigo: string;
  public custo: number;
  public valorunidade: number;
  public qtd_minima: number;
  public dt_ultima_atualizacao: Date;
  public sequencia: number;
  public id: number;
  public valorminimo: number;
  public ativo_integracao: boolean;
  public id_lote: number;
  public id_produto: number;

  /* Produto */

  public name: string;
  public price: number;

  /* Lote */

  public nome_lote: string;
  public cod_lote: string;
  public estoque_lote: number;
  public validade_lote: Date;
  public preco_lote: number;
  public qtde_lote: number; // qtde de lotes do produto (indica se o produto suporta lote)

  /* Importação em Massa */

  public percentual: number; // Percentagem aplicada (ex: 10)
  public tipo_percentual: number; // 'margem' ou 'desconto'

  public tipo_calculo: string; // 'margem' ou 'desconto'
  public tipo: string; // 'percentual' ou 'valor'

  /* Datas da Promoção */

  public dt_inicio: any; // Data de início da promoção
  public dt_fim: any; // Data de fim da promoção

  /* Cota */

  public cota_total: number;
  public cota_utilizada: number;
  public cota_restante: number;

  constructor() { }
}
